import { routingKeyToCounty } from './routingKeyToCounty';

export const evictionRightsCountySlugs = Array.from(
  new Set(Object.values(routingKeyToCounty).map((county) => county.toLowerCase()))
).sort();

export const toTitleCase = (value: string) =>
  String(value || '')
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
